
// cart drawer remove item
(function($){
function refreshDrawer(){
  var $wrap = $('.cart-drawer .drawer__inner, .drawer .drawer__inner').first();
  var urlA  = location.pathname + (location.search ? location.search + '&' : '?') + 'sections=cart-drawer';
  var urlB  = '/cart?view=drawer';
  var urlC  = '/cart';

  // 🔄 show loader
  $('.loading-overlay').removeClass('hidden');

  function swap(html){
    var $tmp = $('<div>').html(html);
    var $new = $tmp.find('.drawer__inner').first();
    if($wrap.length && $new.length){
      $wrap.html($new.html());
      if(!$new.find('.cart-drawer-item').length){
        $('.drawer').addClass('is-empty');
      } else {
        $('.drawer').removeClass('is-empty');
      }
    }

    // ✅ hide loader AFTER DOM update
    setTimeout(function(){
      $('.loading-overlay').addClass('hidden');
    }, 300); // small delay for smoother UI
  }

  $.getJSON(urlA).done(function(json){
    if(json && json['cart-drawer']){ swap(json['cart-drawer']); return; }
    $.get(urlB).done(swap).fail(function(){ $.get(urlC).done(swap); });
  }).fail(function(){
    $.get(urlB).done(swap).fail(function(){ $.get(urlC).done(swap); });
  });
     $(".cart-count-bubble").hide();
}

  $(document).on('click', '.main_product_cus .cart-drawer-item__cart-remove-button', function(e){
  e.preventDefault(); 
  e.stopImmediatePropagation();
  
  var $btn = $(this);
  var mainVid=String($btn.closest('.cart-drawer-item').data('cart-id')||'');
  
  var updates = {};
  
  if(mainVid) updates[mainVid] = 0;
  
  $('cart-drawer-items .free_product_cart[data-cart-id]').each(function(){
    var v = $(this).data('cart-id'); 
    if(v) updates[v] = 0;
  });
  
  $.ajax({
    url: '/cart/update.js',
    type: 'POST',
    dataType: 'json',
    data: {updates: updates},
    success: function() {
      $.ajax({
        url: '/cart/clear.js',
        type: 'POST',
        complete: function() {
          refreshDrawer();
        }
      });
    },
    error: function() {
      refreshDrawer();
    }
  });
});



})(jQuery);





// (function($){
  
//   $(document).on('click','.atc-button.product-form__submit',function(){
//     var $form=$(this).closest('form');
//     var inCart={};
//     $('[data-cart-id]').each(function(){var v=$(this).attr('data-cart-id');if(v)inCart[String(v)]=1;});
//     $form.find('input.free_product-custom[name$="[id]"]').each(function(){
//       var $id=$(this),vid=String($id.data('free-product-id')||$id.val()||'');
//       if(inCart[vid]){
//         var m=($id.attr('name')||'').match(/^items\[(\d+)\]\[id\]$/);
//         if(m){$form.find('input[name="items['+m[1]+'][quantity]"]').remove();}
//         $id.remove();
//       }
//     });
//     var i=1;
//     $form.find('input.free_product-custom[name$="[id]"]').each(function(){
//       var $id=$(this),m=($id.attr('name')||'').match(/^items\[(\d+)\]\[id\]$/);if(!m)return;
//       var old=m[1];
//       $id.attr('name','items['+i+'][id]');
//       var $qty=$form.find('input[name="items['+old+'][quantity]"]');if($qty.length){$qty.attr('name','items['+i+'][quantity]');}
//       i++;
//     });
//   });
// })(jQuery);